import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

const StyledSmall = styled.small`
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const Ellipsis = ({
  value = '',
  initialShowMore = false,
  maxLength = 100,
  wordBreak = 'break-word',
  useHintToExpand = false
}) => {
  const newValue = `${value || ''}`;

  const [showMore, setShowMore] = useState(initialShowMore);

  const canExpand = useMemo(() => newValue.length > maxLength, [
    newValue,
    maxLength
  ]);

  const truncated = `${newValue.slice(0, maxLength)}...`;

  if (canExpand && useHintToExpand) {
    return (
      <React.Fragment>
        <span style={{ wordBreak: wordBreak }}>{truncated}</span>
        <div
          className="hint bottom-right inline clean ml-xs module-color"
          style={{ width: 'auto', height: 'auto' }}
        >
          <StyledSmall>Ver Mais</StyledSmall>
          <div className="hint-content" style={{ top: '100%' }}>
            {newValue}
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <span style={{ wordBreak: wordBreak }}>
      {canExpand && !showMore ? truncated : newValue}{' '}
      {canExpand && (
        <StyledSmall onClick={() => setShowMore(prev => !prev)}>
          {showMore ? 'Ver Menos' : 'Ver Mais'}
        </StyledSmall>
      )}
    </span>
  );
};
